const pushToDataLayer = (data) => {
  if (window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push(data)
  }
}

export default pushToDataLayer
